import { ResourceId } from '../../../../utils/resource-id';
import { createLabsApiClient } from './labs-api-client-factory';
export async function getPricingAndAvailability(labParentId, accessToken, locale, language) {
    const id = labParentId instanceof ResourceId ? labParentId : new ResourceId(labParentId);
    const mlClient = createLabsApiClient(id.subscriptionId, accessToken, locale, language);
    const response = await mlClient.priceAndAvailability.get();
    return response;
}
